import React from "react";

const PartnerContext = React.createContext(null);

export default PartnerContext;
